// src/pages/ems/EmsHome.js
import React from 'react';

const UserHome = () => {
  return (
    <div className="outlet-content" >
      <h2>Welcome to user Dashboard</h2>
    </div>
  );
};

export default UserHome;
